(function dynamicCustomPasswordDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlPasswordConfirm', [])
        .directive('dynamicPasswordConfirm', function () {
            return {
                replace: true,
                require: '^form',
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-password-confirm/custom-control-password-confirm-template.html',
                link: function (scope, elem, attrs, ctrl) {
                    elem.bind('change', function () {
                        ctrl['input' + scope.data.idObject + '_confirm'].$setValidity("matchPassword", scope.confirmPassword === scope.data.metadataValue);
                    });
                }
            };
        });

    angular.module('CustomControlPasswordConfirm')
       .directive('dynamicFilterPasswordConfirm', ['$translate', function () {
           return {
               templateUrl: '/app/directives/custom-control-password-confirm/custom-control-filter-password-confirm-template.html',
               replace: true,
               restrict: 'E',
               controller: [
                   '$scope', function ($scope) {
                       if ($scope.data && !$scope.data.metadataSearchTypeFrom) {
                           $scope.data.metadataSearchTypeFrom = 'EqualIgnoreCase';
                       }
                   }
               ]
           };
       }]);
})();